<template>
    <div class="animated fadeIn">
      <Forms ref="frmThreeCPlus"
             :title="'CONFIGURAÇÃO 3C PLUS'"
             showClearButton
             showSaveButton
             @Clear="onClear"
             @Save="onSave"
      >
        <div class="form-group row">
          <div class="col-12">
            <div class="pb-2 ml-2 pl-1">
              <b-form-checkbox v-model="form.enabled.value" switch :value="true" :unchecked-value="false">
                Habilitar integração 3C Plus
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-md-6 pb-3">
            <label for="domainInput">
              <small v-if="form.domain.required" class="text-danger">*</small>
              Domínio:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                id="domainInput"
                name="domainInput"
                v-model="form.domain.value"
                :maxlength="form.domain.maxlength"
                :required="form.domain.required"
                :state="form.domain.state"
                placeholder="exemplo.3c.plus"
              />
            </div>
          </div>

          <div class="col-md-6 pb-3">
            <label for="socketUrlInput">
              <small v-if="form.socketUrl.required" class="text-danger">*</small>
              URL do Socket:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                id="socketUrlInput"
                name="socketUrlInput"
                v-model="form.socketUrl.value"
                :maxlength="form.socketUrl.maxlength"
                :required="form.socketUrl.required"
                :state="form.socketUrl.state"
                placeholder="wss://new-socket.3c.plus"
              />
            </div>
          </div>

          <div class="col-md-6">
            <label for="connectionTimeoutInput">
              Timeout de Conexão (ms):
            </label>
            <div class="input-group">
              <b-form-input
                type="number"
                id="connectionTimeoutInput"
                name="connectionTimeoutInput"
                v-model="form.connectionTimeout.value"
                :maxlength="form.connectionTimeout.maxlength"
                :state="form.connectionTimeout.state"
                placeholder="15000"
              />
            </div>
          </div>

          <div class="col-md-6">
            <label for="iframeTimeoutInput">
              Timeout do Iframe (ms):
            </label>
            <div class="input-group">
              <b-form-input
                type="number"
                id="iframeTimeoutInput"
                name="iframeTimeoutInput"
                v-model="form.iframeTimeout.value"
                :maxlength="form.iframeTimeout.maxlength"
                :state="form.iframeTimeout.state"
                placeholder="10000"
              />
            </div>
          </div>
        </div>
      </Forms>
    </div>
  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import threeCPlusForm from './threeCPlus-form'
import ThreeCPlusRepository from '@/shared/http/repositories/configurations/threeCPlus'
import { toast, loading } from '@/shared/utils/UIHelper'

const threeCPlusData = {
  id: null,
  enabled: false,
  domain: '',
  socketUrl: 'wss://new-socket.3c.plus',
  connectionTimeout: 15000,
  iframeTimeout: 10000
}

export default {
  name: 'ThreeCPlusConfig',
  mixins: [ActionsForm],
  data () {
    return {
      form: threeCPlusForm,
      data: { ...threeCPlusData }
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    async onLoad () {
      try {
        loading.push()
        const response = await ThreeCPlusRepository.getConfig()
        if (response.status === 200) {
          this.onEdit(response.data)
        } else {
          toast.error('Erro ao carregar configuração', 'Erro')
        }
      } catch (error) {
        console.error(error)
        if (error.response && error.response.status === 404) {
          // Configuração não existe ainda, mantém dados padrão
        } else if (error.response && error.response.status === 403) {
          toast.error('Você não tem permissão para acessar esta configuração', 'Acesso Negado')
        } else if (error.response && error.response.status === 401) {
          toast.error('Sessão expirada. Faça login novamente', 'Não Autorizado')
        } else {
          this.onException(error)
        }
      } finally {
        loading.pop()
      }
    },
    async onCreate () {
      try {
        loading.push()
        const response = await ThreeCPlusRepository.updateConfig(this.data)
        if (response.status === 200) {
          toast.success('Configuração criada com sucesso!')
          this.data.id = response.data.id // Atualiza o ID após criação
        } else {
          toast.error('Erro ao criar configuração', 'Erro')
        }
      } catch (error) {
        console.error(error)
        if (error.response.status === 400) {
          const errorData = error.response.data
          if (errorData.errors) {
            errorData.errors.forEach(err => {
              toast.error(err.message, 'Erro de Validação')
            })
          } else {
            toast.error(errorData.message || 'Dados inválidos', 'Erro de Validação')
          }
        } else if (error.response.status === 403) {
          toast.error('Você não tem permissão para criar esta configuração', 'Acesso Negado')
        } else if (error.response.status === 401) {
          toast.error('Sessão expirada. Faça login novamente', 'Não Autorizado')
        } else {
          this.onException(error)
        }
      } finally {
        loading.pop()
      }
    },
    async onUpdate () {
      try {
        loading.push()
        const response = await ThreeCPlusRepository.updateConfig(this.data)
        if (response.status === 200) {
          toast.success('Configuração atualizada com sucesso!')
        } else {
          toast.error('Erro ao atualizar configuração', 'Erro')
        }
      } catch (error) {
        console.error(error)
        if (error.response.status === 400) {
          const errorData = error.response.data
          if (errorData.errors) {
            errorData.errors.forEach(err => {
              toast.error(err.message, 'Erro de Validação')
            })
          } else {
            toast.error(errorData.message || 'Dados inválidos', 'Erro de Validação')
          }
        } else if (error.response.status === 403) {
          toast.error('Você não tem permissão para atualizar esta configuração', 'Acesso Negado')
        } else if (error.response.status === 401) {
          toast.error('Sessão expirada. Faça login novamente', 'Não Autorizado')
        } else {
          this.onException(error)
        }
      } finally {
        loading.pop()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/threeCPlus/ThreeCPlusConfig.vue